// extracted by mini-css-extract-plugin
var _1 = "SearchViewHeader-module__activeTab--MpXlL";
var _2 = "SearchViewHeader-module__animatedBackground--tujYr";
var _3 = "SearchViewHeader-module__headerSection--go0ja";
var _4 = "SearchViewHeader-module__tab--ZHw4S";
var _5 = "SearchViewHeader-module__verticalHeaderSection--BZIpL";
export { _1 as "activeTab", _2 as "animatedBackground", _3 as "headerSection", _4 as "tab", _5 as "verticalHeaderSection" }
